<template>
    <el-dialog class="el-dialogs" :append-to-body="true" :title="title" :fullscreen="true" :close-on-click-modal="false"
               :visible.sync="visible">
        <div class="pageTop">
            <el-steps :active="stepChange" finish-status="success" align-center>
                <el-step title="选择质量检测方案"></el-step>
                <el-step title="质量检测"></el-step>
                <el-step title="检测报告"></el-step>
            </el-steps>
        </div>
        <el-form size="small" ref="searchForm" :model="searchForm" :rules="rules"
                 label-width="110px">
            <div v-show="stepChange == 0" class="stepCont">
                <el-form-item label="检测方案：" prop="qualityId">
                    <div class="flex_l_c">
                        <el-select v-model="searchForm.qualityId"
                                   placeholder="请选择检测方案" style="width: 30%"
                                   clearable>
                            <el-option
                                    v-for="item in schemeList"
                                    :key="item.id"
                                    :label="item.schemeName"
                                    :value="item.id"
                                    :disabled="item.disabled">
                            </el-option>
                        </el-select>
                        <el-link type="primary" style="margin-left: 30px" @click="schemeDetail()">方案详情</el-link>
                    </div>
                </el-form-item>
                <el-form-item label="检测说明：" prop="inspectionExplain">
                    <el-input
                            type="textarea"
                            placeholder="请输入检测说明(限100字)"
                            v-model="searchForm.inspectionExplain"
                            rows="5" resize="none"
                            style="width: 700px;"
                            maxlength="100"
                    >
                    </el-input>
                </el-form-item>
                <div class="text_center" style="margin-top: 50px">
                    <el-button size="small" type="danger" @click="startDetection()" v-noMoreClick>开始检测</el-button>
                </div>
            </div>
            <div v-show="stepChange == 1" class="stepCont stepCont2">
                <div v-if="percentage != 100" class="text_center detecting">资源质量检测中</div>
                <div v-else class="text_center detecting">资源质量检测完成</div>
                <el-progress :text-inside="true" :stroke-width="26" :percentage="percentage"></el-progress>
                <div class="text_center" style="margin-top: 100px">
                    <el-button :disabled="percentage != 100" size="small" type="danger" @click="nextStep()">下一步
                    </el-button>
                </div>
            </div>
            <div v-show="stepChange == 3" class="stepCont magTopstList">
                <div class="flex_l_t">
                    <div class="flex_l_t reportItem">
                        检测时间：
                        <div>{{ createDate }}</div>
                    </div>
                    <div class="flex_l_t reportItem">
                        检测方案：
                        <div>{{ schemeName }}</div>
                    </div>
                    <div class="flex_l_t reportItem">
                        检测人员：
                        <div>{{ createByName }}</div>
                    </div>
                </div>
                <div class="flex_l_c magTopst b_d m_t1 m_b2">
                    <img src="@/assets/img/abnormalIcon.png" class="zipIcon b_r">
                    <div class="uploadInfo">
                        <div><span class="f_w">检测通过条数: </span><span class="greenColor">{{ successTotal }}条</span>
                        </div>
                        <div><span class="f_w">检测异常条数: </span><span class="redColor">{{ errorTotal }}条</span>
                        </div>
                        <div><span class="f_w">检测总数: </span><span>{{ allTotal }}条</span></div>
                    </div>
                </div>

                <div class="magTopst">
                    检测列表
                    <el-checkbox style="margin-left: 20px;margin-bottom: 10px" v-model="testList.listType"
                                 true-label="1" false-label="0" @change="getDataList(1)">仅显示未通过的
                    </el-checkbox>
                    <el-table
                            :data="dataList"
                            v-loading="loading"
                            size="small" height="300px"
                            class="table" ref="multipleTable" row-key='id' border>
                        <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
                        <el-table-column v-for="(item, index) in tabHead" :key="index"
                                         :prop="item.basicCode"
                                         :label="item.basicRename"
                                         show-overflow-tooltip v-if="item.disabled == '0'">
                            <template slot-scope="scope">
                                <span>{{ listDataFormat(item, scope.row.map.jsonData[item.basicCode]) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="inspectionResult" label="检测状态" fixed="right"
                                         show-overflow-tooltip></el-table-column>
                        <el-table-column
                                fixed="right"
                                min-width="150"
                                label="操作">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="resourceDetails(scope.row)">资源详情
                                </el-button>
                                <el-button type="text" size="small" @click="testingDetails(scope.row)">检测详情
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!--                    <pagination :total="total" :page.sync="testList.current" :limit.sync="testList.size"-->
                    <!--                                @pagination="getDataList"/>-->
                </div>
            </div>
        </el-form>
        <div v-show="stepChange == 3" slot="footer" class="text_center">
            <el-button size="small" @click="reaseatAllData()">重新检测</el-button>
            <el-button size="small" type="primary" @click="downloadReport()" v-no-more-click>下载检测报告</el-button>
            <el-button size="small" type="primary" @click="visible = false">确认</el-button>
        </div>
        <add-quality ref="addQuality"></add-quality>
        <see-file-detail ref="seeFileDetail"></see-file-detail>
        <ResourceAddEditForm ref="resourceAddEditForm"></ResourceAddEditForm>
    </el-dialog>
</template>

<script>
import AddQuality from "@/views/modules/supervise/quality/addQuality.vue";
import SeeFileDetail from "@/components/testReport/seeFileDetail.vue";
import ResourceAddEditForm from "@/views/modules/dyygCollect/library/resourceAddEditForm.vue";

export default {
    name: "qualityInspection",
    components: {ResourceAddEditForm, SeeFileDetail, AddQuality},
    data() {
        return {
            title: '质量检测',
            visible: false,
            stepChange: 0,
            searchForm: {
                qualityId: '',
                inspectionExplain: '',
            },
            rules: {
                qualityId: [
                    {required: true, message: '请选择检测方案', trigger: 'change'}
                ],
            },
            schemeList: [],

            percentage: 0,//资源质量检测中进度值
            timerStore: null,
            successTotal: 0, //检测通过条数
            errorTotal: 0, //检测异常条数
            allTotal: 0, //检测总数

            createDate: '',
            schemeName: '',
            createByName: '',
            testList: {
                listType: 0, //1仅显示未通过的
                current: 1,
                size: 20,
            },
            total: 0,
            loading: false,
            dataList: [],

            tabHead: [],
            selectList: [],
            inspectionCode: '',
        }
    },

    methods: {
        //tabHead:元数据表头  selectList选中的资源
        init(tabHead, selectList) {
            this.inspectionCode = new Date().getTime();
            this.visible = true
            if (this.timerStore) {
                clearInterval(this.timerStore)
            }
            // this.selectList = selectList
            this.selectList = selectList.map(item => {
                return item.id
            })
            this.tabHead = tabHead
            this.reaseatAllData()
            this.getOtherData()
        },

        //重置数据
        reaseatAllData() {
            this.$nextTick(() => {
                this.$refs.searchForm.resetFields();
            })
            this.stepChange = 0
            this.testList.listType = 0
            this.testList.current = 1
            this.testList.size = 20
            this.percentage = 0
        },

        getOtherData() {
            this.$axios(this.api.academic.qualityinspectionQueryList).then(data => {
                if (data && data.status) {
                    this.schemeList = data.data
                }
            })
        },

        //方案详情
        schemeDetail() {
            if (!this.searchForm.qualityId) {
                this.$message('请先选择方案')
                return
            }
            this.$refs.addQuality.init('detail', {id: this.searchForm.qualityId})
        },

        //开始检测
        startDetection() {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.stepChange++;
                    this.simulateProgress();
                    this.$axios(this.api.academic.qualityinspectionreportSave, {
                        ...this.searchForm,
                        resourcesIds: this.selectList,
                        inspectionCode: this.inspectionCode,
                    }, 'post').then(data => {
                        if (data && data.status) {
                            clearInterval(this.timerStore)
                            this.percentage = 100
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }
            })
        },

        //模拟进度
        simulateProgress() {
            this.timerStore = setInterval(() => {
                let randomDigit = Math.floor(Math.random() * 11);
                this.percentage += randomDigit
                if (this.percentage > 80) {
                    clearInterval(this.timerStore)
                }
            }, 500)
        },

        //下一步
        nextStep() {
            this.stepChange += 2
            this.getDataList()
        },

        getDataList(current) {
            if (current) {
                this.testList.current = 1
            }
            this.loading = true
            let data = {
                inspectionCode:this.inspectionCode,
                notPass:this.testList.listType
            }
            this.$axios(this.api.academic.resourcesIdQuality, data, 'get').then(data => {
                this.loading = false
                if (data && data.status) {
                    this.dataList = data.data.list
                    this.createDate = data.data.info[0].createDate
                    this.schemeName = data.data.info[0].schemeName
                    this.createByName = data.data.info[0].createByName
                    data.data.total.forEach(item => {
                        if (item.inspection_result == '通过') {
                            this.successTotal = item.total
                        }
                        if (item.inspection_result == '失败') {
                            this.errorTotal = item.total
                        }
                    })
                    this.allTotal = this.successTotal * 1 + this.errorTotal * 1
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //资源详情
        resourceDetails(row) {
            this.$refs.resourceAddEditForm.init('view', row.resourcesId, '', row.map.basicDataId)
        },

        //检测详情
        testingDetails(row) {
            this.$set(row,'resourcesName',row.map.jsonData.mingcheng)
            this.$refs.seeFileDetail.init(row)
        },

        //下载检测报告
        downloadReport() {
            this.$confirm(`确认下载${this.dataList.length}条检测报告?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.academic.downloadReportByCode, {
                    inspectionCode:this.inspectionCode,
                    notPass:this.testList.listType
                }, 'get', 'blob').then(res => {
                    let blob = new Blob([res.data], {type: 'application/zip'})
                    // let filename = res.headers['content-disposition']
                    let filename = '质量检测报告';
                    let link = document.createElement('a')
                    link.download = decodeURI(filename)
                    link.href = window.URL.createObjectURL(blob)
                    link.click()
                })
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.pageTop {
  width: 70%;
  margin: 0 auto;
}

.stepCont {
  width: 80%;
  margin: 100px auto 0;
}

.stepCont2 {
  width: 60%;
}

.detecting {
  margin-bottom: 30px;
}

.reportItem {
  width: 33%;
}

.magTopst {
  margin-top: 20px;
}

.zipIcon {
  width: 100px;
}

.uploadInfo {
  padding-left: 15px;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
}

.magTopstList {
  margin-top: 20px;
}
</style>